import React from 'react';
import CuadroListaEditable from '../edicion/CuadroListaEditable.js';
import * as Data from '../edicion/data/DataPersonaParientes.js';
import * as DTOs from '../edicion/DTOs/PersonaParientesDTOs.js';
import * as Funciones from '../edicion/funciones/FuncionesPersonaParientes.js';

const ParientesPersona = (props) => {
  const idPersona = props.persona && props.persona.id;

  return (
    <CuadroListaEditable
      titulo="Parientes"
      idPadre={idPersona}
      data={Data}
      dtos={DTOs}
      funciones={Funciones}
    />
  );
};

export default ParientesPersona;
